module.exports = __webpack_public_path__ + "static/media/parkwoods_bylaws.cf47a73e.pdf";